import { showDefaultToast } from "./toast-notify"
import toast from "react-hot-toast"

export const globalToast = {
  /** 全局轻提示（H5：react-hot-toast，默认样式） */
  show(text: string, duration?: number, callback?: () => void) {
    showDefaultToast(text, duration, callback)
  },

  close() {
    toast.dismiss()
  },
}
